module.exports = __webpack_public_path__ + "img/video.1f76491b.jpg";